import * as yup from 'yup';

import { i18n } from '@shared/i18n';
import GenericField from '@shared/fields/generic-field';

import { ClubKitModel } from './club-kit-model';

export default class ClubKitField extends GenericField {
  constructor(name, label, { required = false } = {}) {
    super(name, label);
    this.required = required;
    this.initialValue = Object.keys(ClubKitModel.fields).reduce((result, field) => {
      result[field] = undefined;
      return result;
    }, {});
  }

  forPresenter(value) {
    return value || this.initialValue;
  }

  forFilterInitialValue(value) {
    return value || this.initialValue;
  }

  forFormInitialValue(value) {
    return value || this.initialValue;
  }

  forFilterCast() { }

  forFilterRules() { }

  forFormCast(value) {
    return value || this.initialValue;
  }

  forFormRules() {
    const requiredMessage = i18n('validation.mixed.required').replace('${path}', this.label);
    const allColorsMessage = i18n('teamRegistrationSite.form.validation.allColorsRequired');
    const selectJerseyTypeMessage = i18n('teamRegistrationSite.form.validation.selectJerseyTypeMessage');

    const clubKitValidator = yup.object().shape({
      jersey: yup.object().shape({
        color1: yup.string().required(allColorsMessage),
        color2: yup.string().nullable(),
        type: yup.string().nullable(),
      }),
      pants: yup.object().shape({
        color1: yup.string().required(allColorsMessage),
        color2: yup.string().nullable(),
      }),
    })

    const output = [];

    if (this.required) {
      output.push({
        required: !!this.required,
        message: requiredMessage,
      });
    }

    output.push({
      validator: async (rule, value, callback) => {
        try {
          if (!value.jersey.color1 && !value.pants.color1 && !this.required && !value.jersey.type) return callback();
          if (this.required && !value.jersey.type) return callback(selectJerseyTypeMessage); 
          if (value.jersey.type !== 'solid' && !value.jersey.color2) return callback(allColorsMessage);
          clubKitValidator.validateSync(value);
          callback();
        } catch (error) {
          callback(allColorsMessage);
        }
      },
      trigger: 'change'
    });

    return output;
  }
}